$(document).ready(function(){

	droptabs.init($('.drop-tab-ul'), '#content');

	var bridgecam = $('#bridgecam'),
		shipLinks = $('.ship-link'),
		bridgeList = $('#ship-list-bridge'),
		tabs = $('.tab'),
		bridgeListLinks = $('#ship-list-bridge a'),
		bridgeDefaultImg = bridgeList.find('.tab:first-child > a');
	
	if($.getUrlVar('shipCode')){
		var shipCode = $.getUrlVar('shipCode').toLowerCase()
	}else{
		changeImg(bridgeDefaultImg, bridgecam);
	}

	var pattern = /^[A-Za-z]{2}$/,
		shipCodeTest = pattern.test(shipCode),
		shipFound = null;
	
	bridgecamOffset = $('.bridgecam-holder').offset().top - $('#header').outerHeight() - 10;

	if(shipCodeTest){	
		$.each(bridgeListLinks, function(){
			if($(this).data('ship') == shipCode){
				shipFound = 1;
				changeImg($(this), bridgecam);
			}
		});
		
		if(shipFound != 1) changeImg(bridgeDefaultImg, bridgecam);
	}
	
	shipLinks.on('click',function(event){
		event.preventDefault();
		var imgAddress = $(this);
		changeImg(imgAddress, bridgecam);
		if($(window).width() < 640){
			$('html, body').animate({scrollTop: bridgecamOffset},500);
		}
	});
	
	setInterval(function(){
		var src = bridgecam.prop('src');
		bridgecam.prop('src', ((src.indexOf('?') == -1) ? src : src.substring(0,src.indexOf('?'))) + '?' + new Date().getTime());
	},300000);
	
});

function changeImg(imgAddress, bridgecam){
	bridgecam.prop({'src':imgAddress.prop('href') + '?' + new Date().getTime(),'alt': 'A live picture from the bridge of the ' + imgAddress.text() });
	imgAddress.closest('.drop-tab-ul').find('.tab').removeClass('active');
	imgAddress.closest('.tab').addClass('active');
	var shipName = imgAddress.text();
	var shipCode = imgAddress.attr('data-ship');
	settingUpDataLayer(shipName, shipCode);
}
function settingUpDataLayer(shipName, shipCode) {
	window.digitalData = window.digitalData || {};
	window.digitalData.content = window.digitalData.content || {};
	window.digitalData.content.ship = shipName;
	window.digitalData.content.shipCode = shipCode;
}